function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".f15535ac-4071-442d-8dcf-fc6a5374e4d1{fill:#fff;}.f4749284-7f74-4005-bcb6-cd942e3d936d{fill:#012;stroke:#000;stroke-width:5px;}.a12958ab-6a44-431e-92f2-b9c45823911a,.bb2a2012-30f4-43a3-a4b2-bca8a3e0e486,.f4749284-7f74-4005-bcb6-cd942e3d936d{stroke-miterlimit:10;}.a12958ab-6a44-431e-92f2-b9c45823911a{fill:#00ba89;}.a12958ab-6a44-431e-92f2-b9c45823911a,.bb2a2012-30f4-43a3-a4b2-bca8a3e0e486{stroke:#012;stroke-width:20px;}.bb2a2012-30f4-43a3-a4b2-bca8a3e0e486{fill:none;stroke-linecap:round;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "acb8fb81-8156-4898-a427-68b83a5cfb0d",
  "data-name": "fab238e5-4a98-4e38-b424-c11cc73ee084"
}, /*#__PURE__*/React.createElement("g", {
  id: "b4054d30-5c41-4209-a60b-7cb93dba584d",
  "data-name": "b933f69c-3890-4f42-be36-323a7e684247"
}, /*#__PURE__*/React.createElement("rect", {
  className: "f15535ac-4071-442d-8dcf-fc6a5374e4d1",
  x: 116.07,
  y: 182.75,
  width: 296.94,
  height: 272,
  rx: 12
}), /*#__PURE__*/React.createElement("rect", {
  className: "f15535ac-4071-442d-8dcf-fc6a5374e4d1",
  x: 122.69,
  y: 165.75,
  width: 287.32,
  height: 95.36,
  rx: 12
}), /*#__PURE__*/React.createElement("rect", {
  className: "f15535ac-4071-442d-8dcf-fc6a5374e4d1",
  x: 116.07,
  y: 443.86,
  width: 299.75,
  height: 27.17,
  rx: 12
}), /*#__PURE__*/React.createElement("path", {
  className: "f4749284-7f74-4005-bcb6-cd942e3d936d",
  d: "M269.62,164.41c42.45,0,82.1,4.16,111.33,11.72,17.62,4.54,26.82,9.07,30.84,11.72V450.94c-3.6,2.65-12.81,7.19-30.84,11.72-29.23,7.56-68.88,11.72-111.33,11.72s-82.1-4.16-111.33-11.72c-17.63-4.53-26.82-9.07-30.85-11.72v-263c3.61-2.65,12.82-7.18,30.85-11.72,29.23-7.56,68.87-11.72,111.33-11.72Zm0-15.12c-43.65,0-84.91,4.16-115.74,12.1-29.24,7.56-42.46,16.63-42.46,22.3V455.1c0,5.67,13.22,14.74,42.46,22.3,30.83,7.6,72.12,12.1,115.74,12.1s84.91-4.54,115.74-12.1c29.24-7.56,42.45-16.63,42.45-22.3V183.69c0-5.67-13.21-14.74-42.45-22.3-30.83-7.94-72.09-12.1-115.74-12.1Z",
  transform: "translate(0 0)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a12958ab-6a44-431e-92f2-b9c45823911a",
  d: "M269.94,10C175.83,10,39.35,60.16,34.27,221.11l-9.78,4.61c-18.29,5.26-14,29.53-14.12,48.56L10,327.93v21.46c.14,23.75,39.8,20.1,63.55,20V371a9.76,9.76,0,0,0,9.81,9.69H98.69a9.76,9.76,0,0,0,9.79-9.71h0V225.71h0A9.76,9.76,0,0,0,98.67,216H85.5c6.16-95.85,86.07-159.69,184.44-159.69h-.59c98.37,0,178.28,63.84,184.44,159.69H440.62a9.76,9.76,0,0,0-9.81,9.71h0V371a9.74,9.74,0,0,0,9.77,9.71h15.35a9.76,9.76,0,0,0,9.81-9.69v-1.66c23.75.14,63.4,3.79,63.55-20V327.93l-.38-53.65c-.08-19,4.18-43.3-14.11-48.56l-9.8-4.61C499.94,60.16,363.46,10,269.35,10",
  transform: "translate(0 0)"
})));

var _ref4 = /*#__PURE__*/React.createElement("line", {
  className: "bb2a2012-30f4-43a3-a4b2-bca8a3e0e486",
  x1: 181.85,
  y1: 291.28,
  x2: 238.14,
  y2: 234.58
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  className: "bb2a2012-30f4-43a3-a4b2-bca8a3e0e486",
  x1: 182.25,
  y1: 234.58,
  x2: 238.54,
  y2: 291.28
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  className: "bb2a2012-30f4-43a3-a4b2-bca8a3e0e486",
  x1: 300.75,
  y1: 291.28,
  x2: 357.04,
  y2: 234.58
});

var _ref7 = /*#__PURE__*/React.createElement("line", {
  className: "bb2a2012-30f4-43a3-a4b2-bca8a3e0e486",
  x1: 301.15,
  y1: 234.58,
  x2: 357.44,
  y2: 291.28
});

function SvgLogoErrorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bffab54e-9397-4cc1-80bc-b0709b2fa1c5",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 539.29 492",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoErrorIcon);
export default __webpack_public_path__ + "static/media/logo-error-icon.efa56b3a.svg";
export { ForwardRef as ReactComponent };